<template>
  <el-dialog :visible.sync="dialogVisible" :fullscreen="true" :show-close="false" @close="handleClose">
    <div class="diaInner" id="diaInner">
      <h3 class="diainner_title">
        断路安全作业
        <div class="diainner_title_num">编号：{{ message.no }}</div>
      </h3>
      <table border="1">
        <!-- <tr>
          <td class="title" :colspan="2">作业名称</td>
          <td :colspan="7">{{ message.name }}</td>
        </tr> -->
        <tr>
          <td :colspan="2" class="title">申请单位</td>
          <td>{{ message.applicant?.contrName }}</td>
          <td  class="title">作业单位</td>
          <td :colspan="2">{{ message.businessJson.workUnit }}</td>
          <td class="title">作业负责人</td>
          <td :colspan="2" >{{ getUserName(message.jobExecutorEmpId) }}</td>
<!--          <td>{{ getUserName(message.companyCharger) }}</td>-->
          <!-- <td class="title">申请人</td>
          <td>{{ getUserName(message.applyUserId) }}</td>
          <td class="title">作业申请时间</td>
          <td :colspan="2">{{ message.applyTime }}</td> -->
        </tr>
        <!-- <tr>
          <td class="title" :colspan="2">作业单位</td>
          <td :colspan="2">{{ message.businessJson.workUnit }}</td>
          <td class="title" :colspan="2">负责人</td>
          <td :colspan="3">{{ getUserName(message.companyCharger) }}</td>
        </tr> -->
        <tr>
          <td :colspan="2" class="title">涉及相关单位(部门)</td>
          <td :colspan="2">{{ message.businessJson.rui }}</td>
          <td :colspan="2" class="title">监护人</td>
          <td :colspan="3">{{ getUserName(message.applyUserId) }}</td>
        </tr>
        <tr>
          <td :colspan="2" class="title">断路原因</td>
          <td :colspan="7">{{ message.businessJson.reason }}</td>
        </tr>
<!--        <tr>
          <td class="title">关联其他特殊作业及安全作业证编号</td>
          <td :colspan="2">{{ message.businessJson.ow }}</td>
          <td class="title">涉及的其他特殊作业安全作业证编号</td>
          <td :colspan="2">{{ message.businessJson.owno }}</td>
        </tr>-->
        <tr>
          <td class="title" :colspan="2">关联其他特殊作业及安全作业证编号</td>
          <td :colspan="7">{{ formatPreWorkInfo() }}</td>
        </tr>
        <tr>
          <td :colspan="9">
            <div class="fireplayidea_title">断路地段示意图及相关说明:</div>
            <div class="fireplayidea_cont">
              这里还有个图片（断路地段示意图）<br /><!--TODO 示意图-->
              {{ message.businessJson.description }}
            </div>
            <div class="fireplayidea_right">
              <span>签字：{{ getUserName(message.businessJson.signId) }}</span>
              <span>签字时间：{{ message.businessJson.signTime }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td :colspan="2" class="title">风险辨识结果</td>
          <td :colspan="7">{{ message.businessJson.hi }}</td>
        </tr>
        <tr>
          <td :colspan="2" class="title">断路实施时间</td>
          <td :colspan="7">{{ message.planStartTime }}- {{ message.planEndTime }}</td>
        </tr>
        <tr>
          <td class="title">序号</td>
          <td class="title" :colspan="5">安全措施</td>
          <td :colspan="2" class="title">是否涉及</td>
          <td class="title">确认人</td>
        </tr>
        <tr v-for="(item3, index3) in message.businessJson.sms" :key="index3 + '-' + item3.confirmorId">
          <td>{{ index3 + 1 }}</td>
          <td :colspan="5" class="keepLeft">{{ item3.measures }}</td>
          <td :colspan="2">{{ item3.isInvolve == 1 ? '是' : '否' }}</td>
          <td><i v-html="getSignatureImg(item3.orderNo, 40)"></i></td>
        </tr>
        <tr>
          <td :colspan="2" class="title">安全交底人</td>
          <td :colspan="2">{{ getUserName(message.businessJson.aqjdrId) }}</td>
          <td :colspan="2" class="title">接受交底人</td>
          <td :colspan="3">{{ getUserName(message.businessJson.jsjdrId) }}</td>
        </tr>
        <tr>
          <td :colspan="9">
            <div class="fireplayidea_title">作业负责人意见</div>
            <div class="fireplayidea_cont">{{ message.businessJson.companyChargerComment }}</div>
            <div class="fireplayidea_right">
              <span>签字：<i v-html="getSignatureImg(message.businessJson.companyChargerOrder, 60)" /></span>
              <span>签字时间：{{ message.businessJson.companyChargerTime }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td :colspan="9">
            <div class="fireplayidea_title">所在单位意见</div>
            <div class="fireplayidea_cont">{{ message.businessJson.branchChargerComment }}</div>
            <div class="fireplayidea_right">
              <span>签字：<i v-html="getSignatureImg(message.businessJson.branchChargerOrder, 60)" /></span>
              <span>签字时间：{{ message.businessJson.branchChargerTime }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td :colspan="9">
            <div class="fireplayidea_title">消防、安全管理部门意见</div>
            <div class="fireplayidea_cont">{{ message.businessJson.approveChargerComment }}</div>
            <div class="fireplayidea_right">
              <span>签字：<i v-html="getSignatureImg(message.businessJson.approveChargerOrder, 60)" /></span>
              <span>签字时间：{{ message.businessJson.approveChargerTime }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td :colspan="9">
            <div class="fireplayidea_title">审批部门意见</div>
            <div class="fireplayidea_cont">{{ message.businessJson.deptChargerComment }}</div>
            <div class="fireplayidea_right">
              <span>签字：<i v-html="getSignatureImg(message.businessJson.deptChargerOrder, 60)" /></span>
              <span>签字时间：{{ message.businessJson.deptChargerTime }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td :colspan="9">
            <div class="fireplayidea_title">完工验收</div>
            <div class="fireplayidea_cont">{{ message.acceptanceOpinion }}</div>
            <div class="fireplayidea_right">
              <span>签字：<i v-html="getSignatureImg(0, 60)"></i></span>
              <span>签字时间：{{ message.acceptanceTime }}</span>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <span slot="footer" class="diaFooter">
      <el-button @click="handleClose" size="small">取 消</el-button>
      <el-button v-if="!isWork" type="primary" v-print="'#diaInner'" size="small">打 印</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'blindBoard',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    message: {
      type: Object,
      default: {}
    },
    userList: {
      type: Array,
      default: []
    },
    isWork: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      html: '<span class="textvalue">I ll contact you as soon as possible! < /span>'
    }
  },
  methods: {
    formatPreWorkInfo() {
      if (!this.message.preWorkInfo) {
        return
      }
      let str = []
      let data = JSON.parse(this.message.preWorkInfo)
      for (var i = 0; i < data.length; i++) {
        let element = data[i]
        str.push(`${element.name}(${element.no})`)
      }
      str = str.join(',')
      return str
    },
    handleClose() {
      this.$emit('componentResult', false)
    },
    getUserName(id) {
      for (let i in this.userList) {
        if (id === this.userList[i].id) {
          return this.userList[i].name
        }
      }
    },
    getSignatureImg(orderNum, height = 40) {
      let signatureImg = require('@/assets/img/签字.png');
      let signatureImgHeight = 'auto';
      for (let i in this.message.reviewContentJson) {
        if (orderNum === this.message.reviewContentJson[i].orderNum) {
          let img = this.message.reviewContentJson[i].signatureImg;
          if (img) {
            signatureImg = img;
            signatureImgHeight = height + 'px'
          }
        }
      }

      return '<img style="height: ' + signatureImgHeight + '" src="' + signatureImg + '"/>';
    },
  }
}
</script>

<style src="./commonTable.css" scoped></style>

<style>
.diaInner {
  width: 1020px;
  margin: auto;
}

table {
  width: 1020px;
}

td {
  width: 150px;
}

.diainner_title {
  text-align: center;
  font-size: 28px;
  position: relative;
}

.diainner_title .diainner_title_num {
  position: absolute;
  right: 0;
  bottom: 0;
  font-size: 14px;
  font-weight: normal;
}

.fireplayidea_title {
  font-size: 14px;
  text-align: left;
  font-weight: bold;
}

.fireplayidea_cont {
  line-height: 22px;
  text-align: left;
  margin: 10px 0;
}

.fireplayidea_right {
  text-align: right;
}

.fireplayidea_right span {
  margin-left: 10px;
  width: 220px;
  display: inline-block;
  text-align: left;
}
</style>